import axios from 'axios'

const baseDomain = 'https://api.on-track.in'
const baseDomainv2 = 'https://glacier.on-track.in'

const baseURL = `${baseDomain}/api`
const baseURLv2 = `${baseDomainv2}/api`
const token = `Bearer ${localStorage.getItem('agentToken')}`

export const HTTP = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: 'Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI='
  }
})
export const HTTP2 = axios.create({
  baseURL: baseURLv2,
  headers: {
    Authorization: token
  }
})
export const test = axios.create({
  baseURL: 'http://127.0.0.1:3000/api/',
  headers: {
    Authorization: token
  }
})
